import React from 'react';

const Contact = () => {
  return (
    <section style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Contact Me</h2>
      <p>Drop me a message or connect via social links.</p>
    </section>
  );
};

export default Contact;
